import {FC} from 'react'
import {RootState} from 'setup'
import {
  checkCompliance,
  selectCompliance,
  selectEditOrder,
  selectIsCompliantFetch,
  selectIsCRVEnabled,
  selectIsProductsEditMode,
  selectIsTaxRemoved,
  selectOrderCustomerId,
  setIsDirty,
} from 'app/features/orders/redux/order/orderEditSlice'
import {Order} from 'app/features/orders/models/EditOrderState'
import {useDispatch, useSelector} from 'react-redux'
import {SummaryItem} from 'app/features/orders/componentsv1/shared'
import {ShippingCompliance} from 'app/features/orders/componentsv1/shared/shippingCompliance'
import {isShowCrv} from 'app/features/orders/helper'

type Props = {
  disabled?: boolean
}

const ShippingComplianceTax: FC<Props> = ({disabled}) => {
  const dispatch = useDispatch()
  const order = useSelector<RootState, Order>(selectEditOrder)
  const customerId = useSelector<RootState, string>(selectOrderCustomerId)
  const compliance = useSelector<RootState, any>(selectCompliance)
  const isFetching = useSelector<RootState, boolean>(selectIsCompliantFetch)
  const isProductMode = useSelector<RootState, boolean>(selectIsProductsEditMode)
  const isCrv = useSelector<RootState, boolean>(selectIsCRVEnabled)
  const isTaxRemoved = useSelector<RootState, boolean>(selectIsTaxRemoved)

  const handleCheckCompliance = async () => {
    await dispatch(checkCompliance())
    dispatch(setIsDirty(true))
  }

  return (
    <>
      {isShowCrv({...order, isCrv}) && (
        <>
          <SummaryItem title='Sales Tax' value={order.salesTax} className='text-muted' />
          <SummaryItem title='CRV Tax' value={order.crv} className='text-muted' />
        </>
      )}
      <SummaryItem
        title={
          <ShippingCompliance
            onComplianceCheck={handleCheckCompliance}
            customerId={customerId}
            {...compliance}
            {...order}
            isTaxFetching={isFetching}
            disabled={disabled}
            isShowCrv={isShowCrv({...order, isCrv})}
          />
        }
        value={order.totalTax}
        // isTitleBolder
        isPrimaryActive
        isBetween={isProductMode}
      >
        {isTaxRemoved && <span className='text-muted'>( Tax Removed )</span>}
      </SummaryItem>
    </>
  )
}

export default ShippingComplianceTax
